
import * as forge from 'node-forge';
import CryptoJS from 'crypto-js';
import * as utf8 from 'utf8';


const block_Cipher = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
export const encryptAES = (text: string, key: any) => {
    key = CryptoJS.MD5(utf8.encode(key)).toString(CryptoJS.enc.Hex);
    const cipher = forge.cipher.createCipher('AES-CBC', forge.util.createBuffer(key));
    cipher.start({ iv: block_Cipher });
    cipher.update(forge.util.createBuffer(text));
    cipher.finish();
    const encrypted = cipher.output;
    return forge.util.encode64(encrypted.getBytes());
  };
 export const decryptAES = (text: string, key: any) => {
    key = CryptoJS.MD5(utf8.encode(key)).toString(CryptoJS.enc.Hex);
    const cipher = forge.cipher.createDecipher('AES-CBC', forge.util.createBuffer(key));
    cipher.start({ iv: block_Cipher });
    text = forge.util.decode64(text);
    cipher.update(forge.util.createBuffer(text));
    cipher.finish();
    const decrypted = cipher.output;
    return decrypted.data;
  };

  export const decodeURL= (url: string): string[]=> {
    const encryptedLink = url?.replaceAll(' ', '+');
    const val = decryptAES(encryptedLink ?? '', 'LOG');
    const res = val.split('^~');
    return res;
  }

  export const getInitials = (firstName: string): string => {
    return firstName && firstName.length>0? `${firstName?.charAt(0)?.toUpperCase()}`:'';
}